import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import './css/global.css'

Vue.config.productionTip = false
import router from '@/router/index'
Vue.use(ElementUI);

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
